import './Contact.css';
import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import toast, { Toaster } from 'react-hot-toast';

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    const { user_name, user_email, message } = form.current;

    if (!user_name.value || !user_email.value || !message.value) {
      toast.error('Please fill in all fields.');
      return;
    }

    emailjs.sendForm('service_so2lwt9', 'template_a9k38ha', form.current, 'favNELpUNsLFXXuai')
      .then((result) => {
        console.log(result.text);
        toast.success('Message sent!✅');

      })
      .catch((error) => {
        console.log(error.text);
        toast.error('Error sending message. Please try again.');
      });
  };

  return (
    <>
      <div className='form-contact-container'>
        <p className='contact-container'>Contact me</p>
        <form ref={form} onSubmit={sendEmail}>
          <label>Name</label>
          <input type="text" name="user_name" />
          <label>Email</label>
          <input type="email" name="user_email" />
          <label>Message</label>
          <textarea rows="6" cols="10" name="message" />
          <button className="btn" type="submit">
            Send
          </button>
        </form>
        <Toaster />
      </div>
    </>
  );
};

export default Contact;
